<template>
    <aside v-show="(!isMobile && modals.fullscreen) || (isMobile && modals.hamburgerMenu)"
           :class="{mobile: isMobile ,dash: modals.fullscreen}"
           @click="activeSelect = false"
           class="fs">
        <ul>

            <div class="head fs" :class="{mobile: isMobile}">
                <div class="avatar">
                    <div class="circle">
                        <i class="material-icons" :class="{hide: user.avatar}">person</i>
                        <img :src="user.avatar ? apiBase+'/avatar/'+user.avatar : ''" :class="{hide: !user.avatar}"/>
                    </div>
                </div>
                <span class="name">{{ user.fullname }}</span>
                <span class="id" v-if="['bullden','uccglobal'].indexOf(brand) === -1"># {{ user.id }}</span>
                <span class="email">{{ user.email }}</span>
            </div>

            <button :class="{active: modalFullscreen.page==='deposit'}" class="deposit-btn fs-normal"
                    @click="changePage('deposit')">{{ tokens.fullScreen.deposit }}
            </button>
            <li :class="{active: modalFullscreen.page==='dashboard' }" @click="changePage('dashboard')"><i
                class="material-icons">dashboard</i>{{ tokens.fullScreen.dashboard }}
            </li>
            <li :class="{active: modalFullscreen.page==='personal' }" @click="changePage('personal')"><i
                class="material-icons">account_circle</i>{{ tokens.fullScreen.personalInfo }}
            </li>
            <li :class="{active: modalFullscreen.page==='withdrawal'}" @click="changePage('withdrawal')"><i
                class="material-icons">monetization_on</i>{{ tokens.fullScreen.withdrawal }}
            </li>
            <li v-if="!hideVerificationTab" :class="{active: modalFullscreen.page==='verification'}" @click="changePage('verification')"><i
                class="material-icons">badge</i>{{ tokens.fullScreen.verification }}
            </li>
            <li :class="{active: modalFullscreen.page==='accounts' }" @click="changePage('accounts')"><i
                class="material-icons">content_copy</i>{{ tokens.fullScreen.accounts }}
            </li>
            <li :class="{active: modalFullscreen.page==='support' }" @click="changePage('support')"><i
                class="material-icons">chat</i>{{ tokens.fullScreen.liveChat }}
            </li>
            <li v-if="savingExist" :class="{active: modalFullscreen.page==='savings'}" @click="changePage('savings')"><i
                class="material-icons">savings</i>{{ tokens.fullScreen.savings }}
            </li>
            <li :class="{active: modalFullscreen.page==='settings' }" @click="changePage('settings')"><i
                class="material-icons">settings</i>{{ tokens.fullScreen.settings }}
            </li>
            <li class="personal-btns" :class="{fool: brand === 'mirabud'}" v-if="personalBtns">
                <a href="https://anydesk.com/download">
                    <img :src="staticBase + `misc/AnyDesk-logo.png`" alt="">
                    AnyDesk
                </a>
                <a href="https://teamviewer.com/download">
                    <img :src="staticBase + `misc/TeamViewer-logo.png`" alt="">
                    TeamViewer
                </a>
                <a href="https://www.aeroadmin.com" v-if="brand === 'mirabud'">
                    <img :src="staticBase + `misc/aeroadmin.png`" alt="">
                    AeroAdmin
                </a>
            </li>
        </ul>
        <div class="side-menu">
            <div class="menu" :class="{hide: modals.fullscreen}">
                <div class="item" :class="{active: modalMenu.market, isMobile: isMobile}"
                     @click="showMenuModal('market')">
                    <i class="material-icons">view_list</i>
                    <span>{{ tokens.sideMenu.marketWatch.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.market, minus: modalMenu.market && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('market')">{{ modalMenu.market ? 'remove_circle' : 'add_circle' }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.orders, isMobile: isMobile}"
                     @click="showMenuModal('orders')">
                    <i class="material-icons">local_mall</i>
                    <span>{{ tokens.sideMenu.activeOrders.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.orders, minus: modalMenu.orders && modalMenuSplit > 0 }"
                       @click.stop="toggleWidget('orders')">{{ modalMenu.orders ? 'remove_circle' : 'add_circle' }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.history, isMobile: isMobile}"
                     @click="showMenuModal('history')">
                    <i class="material-icons">history</i>
                    <span>{{ tokens.sideMenu.tradingHistory.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.history, minus: modalMenu.history && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('history')">{{
                            modalMenu.history ? 'remove_circle' : 'add_circle'
                        }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.calendar, isMobile: isMobile}"
                     @click="showMenuModal('calendar')">
                    <i class="material-icons">today</i>
                    <span>{{ tokens.sideMenu.economicCalendar.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.calendar, minus: modalMenu.calendar && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('calendar')">{{
                            modalMenu.calendar ? 'remove_circle' : 'add_circle'
                        }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.news, isMobile: isMobile}" @click="showMenuModal('news')">
                    <i class="material-icons">campaign</i>
                    <span>{{ tokens.sideMenu.marketNews.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.news, minus: modalMenu.news && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('news')">{{ modalMenu.news ? 'remove_circle' : 'add_circle' }}</i>
                </div>
            </div>
        </div>
        <li class="logout" v-on:click="logout"><i class="material-icons">logout</i><span>{{
                tokens.fullScreen.logOut
            }}</span></li>

    </aside>
</template>

<script>
import {mapGetters} from 'vuex'
import {MODAL, MODAL_FULLSCREEN, MODAL_MENU, ACTIVE_CURRENCY} from "@/store/mutations.type";
import {isMobile} from '@/common/helpers'
import {LOGOUT} from "@/store/actions.type";
import {PERSONAL_BTNS, REST_ENDPOINT, STATIC_BASE, BRAND, HIDE_VERIFICATION_TAB} from "@/common/config";

export default {
    name: "SideMenu",
    data() {
        return {
            isMobile: isMobile(),
            staticBase: STATIC_BASE,
            apiBase: REST_ENDPOINT,
            personalBtns: PERSONAL_BTNS,
            activeSelect: false,
            brand: BRAND,
            hideVerificationTab: HIDE_VERIFICATION_TAB
        }
    },
    methods: {
        showMenuModal(item) {
            this.$store.commit(MODAL, {
                menu: true
            })

            let m = {
                orders: false,
                history: false,
                market: false,
                calendar: false,
                news: false
            }

            m[item] = true

            this.$store.commit(MODAL_MENU, m)
            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })
        },
        toggleWidget(widget) {
            let n = JSON.parse(JSON.stringify(this.modalMenu))

            n[widget] = !n[widget]

            this.$store.commit(MODAL_MENU, n)

            let hideMenuModal = true

            for (let i in n) {
                if (n[i]) {
                    hideMenuModal = false
                    break
                }
            }

            if (hideMenuModal) {
                this.$store.commit(MODAL, {
                    menu: false,
                    sideMenu: !isMobile()
                })
            }

            if (n[widget] && !this.modals.menu) {
                this.$store.commit(MODAL, {
                    menu: true,
                    sideMenu: false
                })
            }

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

        },
        changePage(page) {
            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

            this.$store.commit(MODAL_FULLSCREEN, {
                page
            })
        },
        changeCurrency(currency) {
            localStorage.activeCurrency = currency
            this.$store.commit(ACTIVE_CURRENCY, currency)
        },
        logout() {
            this.$store.dispatch(LOGOUT)
        },
    },
    computed: {
        ...mapGetters(['tokens', 'modals', 'modalMenu', 'modalFullscreen', 'user', 'accounts', 'activeAccount', 'activeCurrency','savingExist']),
        modalMenuSplit() {
            let i = 0
            for (let n in this.modalMenu) {
                if (this.modalMenu[n]) {
                    i++
                }
            }

            return i
        }
    }
}
</script>

<style scoped>

.dashboard-menu {
    padding-top: 20px;
    margin-top: 20px;
    border-top: 2px solid var(--white);
}

.menu {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
}

.menu .item {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    font-weight: 400;
    font-size: 0.9em;
    position: relative;
    padding: 0 10px;
    border-bottom: 1px solid var(--background-dark);
    transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
    text-align: center;
}

.menu .item i {
    margin-bottom: 5px;
}

.menu .item span {
    text-align: center;
}

.menu .item:hover, .menu .item.active {
    color: var(--white);
    background-color: var(--background-light);
}

.menu .item:hover .toggle-btn, .toggle-btn.minus {
    opacity: 1;
}

.head {
    place-self: center end;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px 0;
}

.head.mobile {
    padding: 40px 0;
}

.avatar {
    transition: color ease-in-out 0.3s;
    display: flex;
    align-items: center;
}

.avatar .circle {
    height: 70px;
    width: 70px;
    border-radius: 50%;
    background-color: var(--background);
    transition: background-color ease-in-out 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.avatar .circle img {
    height: 70px;
    width: 70px;
    object-fit: cover;
}

.name {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #91BDFF;
    margin: 15px 0 15px;
    max-width: 175px;
    text-align: center;
    word-wrap: break-word;
    word-break: break-word;
}

.id,
.email {
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
}

.id {
    color: #C0C0C0;
}

.email {
    color: var(--white);
}

.toggle-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 1.6em;
    color: var(--font);
    cursor: pointer;
    transition: color ease-in-out 0.3s, opacity ease-in-out 0.3s;
    opacity: 0;
}

.isMobile .toggle-btn {
    opacity: 1;
    top: 1px;
    right: 3px;
}

.isMobile .material-icons:last-child {
    display: none;
}

.isMobile .material-icons {
    padding: 0;
}

.toggle-btn:hover {
    color: var(--white);
}

aside {
    background: var(--background-dark-mid);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 10;
    padding: 0 38px;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    overflow-y: scroll;
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, .1);
}

aside {
    padding: 0 15px;
}

aside li {
    font-size: 24px;
    grid-auto-rows: 50px;
    line-height: 24px;
}

aside i {
    font-size: 21px;
    padding: 0 20px 0 0;
}

aside li,
.logout {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-rows: 50px;
    place-items: center start;
    cursor: pointer;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: var(--font);
}

aside li:hover,
aside li.active {
    color: var(--white);
}

.menu {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    padding: 20px 0;
}

.menu .item {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    font-weight: 400;
    font-size: 0.9em;
    position: relative;
    padding: 0 10px;
    border-bottom: 1px solid var(--background-dark);
    transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
}

.menu .item i {
    margin-bottom: 5px;
}

.menu .item span {
    text-align: center;
}

.menu .item:hover, .menu .item.active {
    color: var(--white);
    background-color: var(--background-light);
}

.menu .item:hover .toggle-btn, .toggle-btn.minus {
    opacity: 1;
}

.toggle-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 1.6em;
    color: var(--font);
    cursor: pointer;
    transition: color ease-in-out 0.3s, opacity ease-in-out 0.3s;
    opacity: 0;
}

.isMobile .toggle-btn {
    opacity: 1;
    top: 1px;
    right: 3px;
}

.toggle-btn:hover {
    color: var(--white);
}

.deposit-btn.fs-normal {
    width: 100%;
    margin: 0 0 20px;
}

.avatar .circle i {
    padding: 0 20px 0;
}

.personal-btns.fool {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, max-content);
    width: 100%;
    margin-top: 15px;
}


.personal-btns.fool a {
    width: 100%;
}

.personal-btns {
    display: grid;
    grid-template-columns: repeat(2, auto);
    place-items: center;
    gap: 10px;
}

.personal-btns img {
    height: 25px;
}

.personal-btns a {
    color: var(--white);
    text-decoration: none;
    display: inline-grid;
    place-items: center;
    grid-template-columns: repeat(2, max-content);
    gap: 5px;
    font-size: 12px;
    border-radius: 5px;
    padding: 5px;
    transition: transform .3s ease-in-out;
}

.personal-btns a:hover{
    transform: scale(1.05);
}

.personal-btns a:active{
    transform: scale(.95);
}

.personal-btns a:nth-child(1) {
    border: 1px solid #ef443b;
}

.personal-btns a:nth-child(2) {
    border: 1px solid #178de5;
}

.personal-btns a:nth-child(3) {
    border: 1px solid #eb521a;
}

@media (min-width: 1000px) {
    .personal-btns {
        gap: .5vw;
    }

    .personal-btns img {
        height: 1.2vw;
    }

    .personal-btns a:nth-child(1){
        border: .1vw solid #ef443b;
    }

    .personal-btns a:nth-child(2){
        border: .1vw solid #178de5;
    }

    .personal-btns a:nth-child(3){
        border: .1vw solid #eb521a;
    }

    .personal-btns a {
        gap: .2vw;
        font-size: .7vw;
        padding: .3vw;
        border-radius: .2vw;
    }

    .head {
        padding: 1vw 0;
    }

    .avatar .circle i {
        padding: 0 1vw 0;
    }

    .head.fs .avatar .circle {
        width: 3.5vw;
        height: 3.5vw;
    }

    .head.fs .avatar .circle img {
        width: 100%;
        height: 100%;
    }

    .head.fs .name {
        font-size: 1.25vw;
        line-height: 1.8vw;
        max-width: 9vw;
        margin: 1vw 0;
    }

    .head.fs .id,
    .head.fs .email {
        font-size: 1vw;
        line-height: 1.4vw;
    }

    .deposit-btn.fs-normal {
        margin: 0 0 1.2vw;
    }

    aside.fs {
        padding: 0 2vw;
    }

    aside.fs li {
        font-size: 1.2vw;
        grid-auto-rows: 2.5vw;
        line-height: 1.4vw;
    }

    aside.fs i {
        font-size: 1.2vw;
        padding: 0 1vw 0 0;
    }

}

@media (max-width: 1000px) {
    aside.fs li {
        grid-auto-rows: 50px;
    }
}

@media (max-width: 500px) {

    aside.mobile {
        padding: 70px 20px 0;
    }

}

</style>
